import { useNavigateForm } from '@/shared/application/hooks'
import { useEffect } from 'react'

const useHomepage = () => {
  const { goToOffers } = useNavigateForm()
  useEffect(() => {
    goToOffers()
  }, [goToOffers])
}

export { useHomepage }
